import { createI18n } from 'vue-i18n'
import { setDayJsLocale } from '@/utils/libraries/dayjs'
import en from '../../../../../packages/translations/v2/en.json'

const defaultLocale = 'en'

const i18n = createI18n({
  mode: 'composition',
  allowComposition: true,
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  formatFallbackMessages: true,
  silentTranslationWarn: true, // hide the warning about missing translations to avoid noise in dev console
  silentFallbackWarn: false, // keep it to find missing translations in fallback locale
  globalInjection: false,
  warnHtmlInMessage: 'off', // disable of the Detected HTML in message
  messages: {
    en,
  },
})

export function changeLocale(locale: string): void {
  const html = document.querySelector('html')
  if (html) {
    html.setAttribute('lang', locale)
  }

  if (locale !== defaultLocale) {
    setDayJsLocale(locale)
  }
}

export function changeLanguageMessages(
  locale: string,
  messagesToAdd: Record<string, string>,
): void {
  const emptyMessagesRemoved: Record<string, string> = Object.keys(
    messagesToAdd,
  )
    .filter((k) => messagesToAdd[k] !== '')
    .reduce((a, k) => ({ ...a, [k]: messagesToAdd[k] }), {})
  changeLocale(locale)
  i18n.global.setLocaleMessage(locale, emptyMessagesRemoved)
  i18n.global.locale = locale
}

/**
 * @deprecated
 * This was created to use localization outside of Vue components, like in helpers or utils.
 * But it using this causes side effects in the module when loading
 * therefore never use this in .vue files (use `useI18n` instead)
 * and consider refatoring the portion in the helpers that need localization into composables
 * that can be used in .vue files.
 * Example of refactoring: see `useUsers` composable and its usage.
 */
export const t = i18n.global.t

export const getActiveLocale = (): string => i18n.global?.locale

export default i18n
